import {
  jb_cta_small_css_default
} from "./chunk.63UKOZIJ.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  Linkable,
  getLinkIcon,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  isPartiallyInViewPort
} from "./chunk.JTCOOS2A.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-cta-small/jb-cta-small.ts
var JbCtaSmall = class extends Linkable(i) {
  constructor() {
    super(...arguments);
    this.alwaysVisible = false;
    this._ctaSmall = {
      el: null,
      hero: null,
      footer: null
    };
    this._expandedWidth = 0;
    // A focused CTA must stay on screen, or keyboard users land on a hidden link (WCAG 2.4.7, 2.4.11).
    this._isFocused = false;
    this._isHovered = false;
    this._isVisible = false;
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this._ctaSmall.el = this.renderRoot.querySelector(".cta-small");
    this._ctaSmall.hero = document.querySelector(
      "jb-info-page-hero, jb-campaign-page-hero-fullscreen, jb-article-page-hero, jb-moment-page-hero, jb-news-page-hero, jb-simple-page-hero"
    );
    this._ctaSmall.footer = document.querySelector("jb-footer");
    if (!this._ctaSmall.el) return;
    if (this.link.data.type === "download" && this.link?.href) {
      this._ctaSmall.el?.setAttribute("download", "");
    }
    this._expandedWidth = this.shadowRoot.querySelector("span")?.offsetWidth ?? 0;
    window.addEventListener("scroll", () => this._showHide());
    setTimeout(() => {
      this._showHide();
    }, 0);
  }
  _aboveTheFold() {
    const viewportHeight = window.innerHeight;
    if (this._ctaSmall.hero) {
      const heroBottomEdgeOffset = this._ctaSmall.hero.getBoundingClientRect().bottom;
      return heroBottomEdgeOffset > viewportHeight / 2;
    }
    const scrollPosition = window.scrollY;
    return scrollPosition < viewportHeight / 2;
  }
  _mouseOut() {
    this._isHovered = false;
  }
  _mouseOver() {
    if (!this._isVisible) this._isVisible = true;
    this._isHovered = true;
  }
  _nearBottom() {
    const buttonHeight = this._ctaSmall.el?.offsetHeight ?? 0;
    return window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - buttonHeight;
  }
  _onFocus() {
    this._isFocused = true;
    this._mouseOver();
  }
  _onFocusOut() {
    this._isFocused = false;
    this._mouseOut();
    this._showHide();
  }
  _showHide() {
    if (!this.alwaysVisible && !this._isFocused && (this._aboveTheFold() || this._ctaSmall.footer && isPartiallyInViewPort(this._ctaSmall.footer) || this._nearBottom())) {
      this._isVisible = false;
    } else {
      this._isVisible = true;
    }
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "cta-small",
      interaction_element: "cta"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <a
        @jb-link:clicked=${this._tracking}
        data-linkable
        class="cta-small ${e({
      [this.link.data.type]: this.link.data.type,
      "cta-small--hover": this._isHovered,
      "cta-small--visible": this._isVisible
    })}"
        data-fly-tweak="0,0,${this._expandedWidth},-${this._expandedWidth}"
        @focus="${() => this._onFocus()}"
        @focusout="${() => this._onFocusOut()}"
        @mouseenter="${() => this._mouseOver()}"
        @mouseleave="${() => this._mouseOut()}"
      >
        <span
          class="text"
          data-fly-catcher
        >
          <span class="text-wrap">${this.text}</span>
        </span>
        <span class="icon">${getLinkIcon(this.link.data.type)}</span>
      </a>
    `;
  }
};
JbCtaSmall.styles = [reset_css_default, jb_cta_small_css_default];
__decorateClass([
  n({ type: Boolean })
], JbCtaSmall.prototype, "alwaysVisible", 2);
__decorateClass([
  n()
], JbCtaSmall.prototype, "text", 2);
__decorateClass([
  r()
], JbCtaSmall.prototype, "_isHovered", 2);
__decorateClass([
  r()
], JbCtaSmall.prototype, "_isVisible", 2);
JbCtaSmall = __decorateClass([
  customElement("jb-cta-small")
], JbCtaSmall);

export {
  JbCtaSmall
};
